module.exports = __webpack_public_path__ + "media/applicants/icon-carrot-e5abebad.png";